import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { fetchCollection } from './utils';
import './login_signup.css';

function ListTournaments() {
  const [loading, setLoading] = useState(true);
  const [tournaments, setTournaments] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    async function fetchTournaments() {
      setLoading(true);
      const docs = await fetchCollection("tournaments");
      const allTournamentsListLocal = []
      docs.forEach((doc) => {
        // doc.data() is never undefined for query doc snapshots
        const docData = doc.data()
        const tournamentDisplayName = `${docData.tournamentName} @ ${docData.golfCourses[0]}`
        const tournamentObject = {
            id: doc.id,
            ...docData
        }
        allTournamentsListLocal.push(tournamentObject)
      })
      // Sort tournaments by startDate ascending
      allTournamentsListLocal.sort((a, b) => {
        const dateA = new Date(a.startDate);
        const dateB = new Date(b.startDate);
        return dateA - dateB;
      });
      setTournaments(allTournamentsListLocal)
      setLoading(false);
    }
    fetchTournaments();
  }, []);

  if (loading) {
    return (
      <div className="admin-login-bg">
        <div className="admin-login-card">
          <div className="admin-login-loading">
            <div className="admin-login-spinner"></div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="admin-login-bg">
      <div className="admin-login-card" style={{ maxWidth: 700 }}>
        <h1 className="admin-login-title">All Tournaments</h1>
        <button
            className="admin-login-btn"
            type="button"
            style={{ marginBottom: "1.5rem", padding: "0.4rem 1.1rem", fontSize: "0.97rem" }}
            onClick={() => navigate('/admin')}
        >
            ← Back to Admin Home
        </button>
        <h2 className="admin-login-subtitle" style={{ fontWeight: 500, fontSize: "1.1rem", color: "#374151", marginTop: "0.2rem", marginBottom: "1.5rem" }}>
          Click on a tournament to edit.
        </h2>
        <div style={{ marginTop: "2rem" }}>
          {tournaments.length === 0 && <div>No tournaments found.</div>}
          {tournaments.map(t => (
            <div
              key={t.id}
              className="admin-tournament-list-item"
              style={{
                background: "#f3f6fd",
                borderRadius: "0.8rem",
                padding: "1rem",
                marginBottom: "1rem",
                cursor: "pointer",
                boxShadow: "0 2px 8px rgba(37,99,235,0.04)",
                transition: "box-shadow 0.2s"
              }}
              onClick={() => navigate(`/admin/editTournament?${t.id}`)}
            >
              <div style={{ fontWeight: 700, fontSize: "1.1rem", color: "#2563eb" }}>{t.tournamentName}</div>
              <div style={{ fontSize: "0.97rem", color: "#374151" }}>{t.golfCourses?.[0]}</div>
              <div style={{ fontSize: "0.95rem", color: "#6b7280" }}>{t.startDate} - {t.endDate}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default ListTournaments;